import { Button } from "@progress/kendo-react-buttons";
import { Checkbox } from "@progress/kendo-react-inputs";
import { useLocalization } from "@progress/kendo-react-intl";
import { Popup } from "@progress/kendo-react-popup";
import { columnsIcon } from "@progress/kendo-svg-icons";
import { useRef, useState, useEffect } from "react";

export const ConfiguratorToggleColumnsGrid = (props: any) => {

    const anchor = useRef(null);

    const localizationService = useLocalization();

    const [showPopup, setShowPopup] = useState(false);

    const onToggleColumn = () => {
      setShowPopup(!showPopup);
    };

    const onChange = (event: any) => {
      props.onChange(event)
    }

    useEffect(() => {
      const onMouseDown = (event: any) => {
        let wrappingEl = document.querySelector('.configurator-wrap-element');
        if (wrappingEl && !wrappingEl.contains(event.target)) {
          setShowPopup(false);
        }
      };

      window.addEventListener('mousedown', onMouseDown);
      return () => window.removeEventListener('mousedown', onMouseDown);
    }, []);

    return (
      <div>
        <span ref={anchor} title={localizationService.toLanguageString('show_hide_columns', 'NOT_FOUND')}>
          <Button
            onClick={onToggleColumn}
            themeColor={'primary'}
            svgIcon={columnsIcon}
            size="small"
          />
        </span>
        <Popup
          margin={{ horizontal: 0, vertical: 10 }}
          anchor={anchor.current}
          anchorAlign={{ vertical: 'bottom', horizontal: 'right' }}
          popupAlign={{ vertical: 'top', horizontal: 'right' }}
          popupClass={"show-hide-columns"}
          show={showPopup}
          animate={false}
        >
          <div
            className="configurator-wrap-element"
            style={{
              padding: '10px',
              backgroundColor: '#fefefe',
              border: '1px solid #ddd'
            }}
          >
            <div style={{ paddingBottom: '5px' }}>{localizationService.toLanguageString('show_hide_columns', 'NOT_FOUND')}:</div>
            <div>
              {
                props.columns?.length > 0 ?
                props.columns?.map((column: any, index: any) => {                  
                    return (
                      (column.field != 'mac' && column.field != 'deviceMac') &&  
                      //column?.title != 'Info' &&
                      <div style={{ padding: '3px 5px 5px 0px' }} key={index}>
                        <Checkbox
                          //id={column.field}
                          name={column.field}
                          defaultChecked={column.show}
                          onChange={onChange}
                          label={column.title}
                        />
                      </div>
                    )
                  })
                  :
                  props.columns?.columns?.map((column: any, index: any) => {
                    return (
                      <div style={{ padding: '3px 5px 5px 0px' }} key={index}>
                        <Checkbox
                          //id={column.field}
                          name={column.field}
                          defaultChecked={column.show}
                          onChange={onChange}
                          label={column.title}
                        />
                      </div>
                    )
                  })

              }
            </div>
          </div>
        </Popup>
      </div>
    )
  }